// extracted by mini-css-extract-plugin
module.exports = {"customCollapse":"styele_customCollapse__G3Ov_"};